import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import FoldText from "@/components/FoldText/FoldText";

export default function CinematicBand({
  img,
  label,
  title,
  sub,
  testId,
  right = false,
  imgPositionClassName = "object-center",
  heightClassName = "h-[55vh] lg:h-[72vh] min-h-[520px]",
  imgScale = 1,
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section
      ref={ref}
      data-testid={testId}
      className={`relative overflow-hidden bg-black ${heightClassName}`}
    >
      <motion.img
        src={img}
        alt=""
        style={{ y, scale: imgScale }}
        className={`absolute left-0 w-full h-[130%] -top-[15%] object-cover ${imgPositionClassName}`}
      />
      <div
        className="absolute inset-0"
        style={{
          background: right
            ? "linear-gradient(to left, rgba(5,5,8,0.85) 15%, rgba(5,5,8,0.25) 55%, rgba(5,5,8,0.4))"
            : "linear-gradient(to right, rgba(5,5,8,0.85) 15%, rgba(5,5,8,0.25) 55%, rgba(5,5,8,0.4))",
        }}
      />
      <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black to-transparent" />

      <div className="relative h-full max-w-[1280px] mx-auto px-6 lg:px-14 flex items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className={`max-w-xl ${right ? "ml-auto text-right" : ""}`}
        >
          <div className={`flex items-center gap-3 mb-5 ${right ? "justify-end" : ""}`}>
            <span className="w-2 h-2 bg-[#FFD166] rotate-45" />
            <span className="font-mono-file text-[11px] tracking-[0.3em] text-[#FFD166] uppercase">
              {label}
            </span>
          </div>
          <h2 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-white">
            <FoldText
              text={title}
              splitBy="word"
              trigger="scroll"
              fontSize="inherit"
              fontWeight="inherit"
              color="inherit"
            />
          </h2>
          <p className="mt-5 font-serif-jack italic text-xl sm:text-2xl text-white/75 leading-snug">
            {sub}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
